<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/passageiros">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">

                    <!-- AVISO DE ENDERECO PENDENTE -->
                    <v-alert v-if="!page.isNew && !dataset.data.address_iid" dense text type="warning"
                        class="body-2 mb-4" icon="mdi-map-marker-alert">
                        Passageiro sem endereço localizado no mapa. Sem isso o cálculo de rota e de valor das
                        viagens não funciona para ele.
                    </v-alert>

                    <!-- DADOS PESSOAIS -->
                    <v-card class="card-form-outlined mb-4">
                        <v-card-title class="section-title">
                            <v-icon left color="primary" small>mdi-account-outline</v-icon>
                            Dados do passageiro
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined id="name" v-model="dataset.data.name" label="Nome"
                                        hide-details="auto" :rules="[$rules.required]"></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field dense outlined id="matricula"
                                        v-model="dataset.data.registration" label="Matrícula" hide-details="auto"
                                        :rules="[$rules.required]"></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field dense outlined id="cellphone" v-mask="'(##) #####-####'"
                                        v-model="dataset.data.phone_number" label="Celular" hide-details="auto"
                                        placeholder="(51) 99999-9999" persistent-placeholder></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- ENDERECO -->
                    <v-card class="card-form-outlined mb-4">
                        <v-card-title class="section-title">
                            <v-icon left color="primary" small>mdi-map-marker-outline</v-icon>
                            Endereço
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete dense outlined :items="dataset.addresses" label="Endereço"
                                        :loading="dataset.addressLoading" :search-input.sync="searchAddress"
                                        v-model="dataset.data.address" item-value="iid" item-text="name"
                                        hide-details="auto" return-object :filter="() => true"
                                        @change="onAddressSelected($event)"
                                        prepend-inner-icon="mdi-magnify"
                                        no-data-text="Digite para buscar o endereço"
                                        hint="Busca pelo Google Maps — selecione uma das sugestões"
                                        persistent-hint>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense outlined id="district" v-model="dataset.data.district"
                                        label="Bairro" hide-details="auto"></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense outlined id="complement"
                                        v-model="dataset.data.complement" label="Complemento"
                                        hide-details="auto"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4" v-if="!manualCoords">
                                    <v-text-field dense outlined readonly
                                        label="Coordenadas" hide-details="auto"
                                        :value="coordsLabel"
                                        :append-icon="hasCoords ? 'mdi-check-circle-outline' : 'mdi-alert-outline'"
                                        :class="hasCoords ? 'coords-ok' : 'coords-missing'"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-switch v-model="manualCoords" color="primary" dense hide-details
                                        class="mt-0"
                                        label="Informar coordenadas manualmente"></v-switch>
                                    <p class="caption grey--text mb-0">
                                        Use quando a busca não encontrar o endereço. As coordenadas informadas
                                        substituem as do mapa.
                                    </p>
                                </v-col>
                            </v-row>

                            <v-row v-if="manualCoords">
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense outlined id="latitude" label="Latitude"
                                        v-model="dataset.data.address_lat" hide-details="auto"
                                        placeholder="-30.010129" persistent-placeholder
                                        :rules="[coordinateRule]"></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense outlined id="longitude" label="Longitude"
                                        v-model="dataset.data.address_lng" hide-details="auto"
                                        placeholder="-51.170841" persistent-placeholder
                                        :rules="[coordinateRule]"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- VINCULO -->
                    <v-card class="card-form-outlined mb-4">
                        <v-card-title class="section-title">
                            <v-icon left color="primary" small>mdi-domain</v-icon>
                            Vínculo
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select :loading="dataset.loading" dense outlined :items="dataset.customers"
                                        label="Empresa" v-model="dataset.data.customer_id" item-value="id"
                                        item-text="name" hide-details="auto"
                                        @change="changeCustomer"></v-select>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-select dense outlined id="costCenter" :items="dataset.costCenters"
                                        label="Centro de custo" v-model="dataset.data.cost_center_id"
                                        item-value="id" :item-text="item => item.name ? item.name : item.code"
                                        hide-details="auto" :rules="[$rules.required]"
                                        no-data-text="Selecione a empresa primeiro" />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-textarea dense outlined id="obs" label="Observações"
                                        v-model="dataset.data.obs" rows="2" auto-grow hide-details="auto"
                                        placeholder="Informações adicionais sobre o passageiro"
                                        persistent-placeholder></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-col>
            </v-row>
        </v-form>

    </v-container>

</template>

<script>
import string from "@/common/util/string"
import object from "@/common/util/object"

import axios from "axios"
import vehicleColorTypesData from '@/common/data/vehicle-color-types.data';
import vehicleCarMakesData from '@/common/data/vehicle-car-makes.data';
import vehicleCarModelsData from '@/common/data/vehicle-car-models.data';

import debounce from 'lodash/debounce'

export default {
    name: "UpboxDetails",

    data: () => ({
        page: {
            title: "",
            isNew: true
        },
        dataset: {
            data: {},
            costCenters: [],
            breadcrumbItems: [],
            loading: false,
            loadingAddress: false,
            submit: {
                brand: null
            },
            vehicleColorTypesData,
            vehicleCarMakesData,
            vehicleCarModelsData,
            customers: [],
        },
        dataForm: {
            validForm: true,
        },
        searchAddress: null,
        addressSessionToken: null,

        // Libera lat/lng para digitacao quando o Maps nao encontra o endereco
        manualCoords: false,
    }),

    computed: {
        // Texto e icone saem da mesma condicao: antes o icone testava o valor cru
        // e uma string vazia passava como verdadeira, mostrando o check de sucesso
        // junto da mensagem de nao localizado.
        hasCoords() {
            const lat = Number(this.dataset.data.address_lat);
            const lng = Number(this.dataset.data.address_lng);

            return !!(lat && lng && !isNaN(lat) && !isNaN(lng));
        },

        // Mostra a localizacao resolvida em vez de dois campos de lat/lng soltos,
        // que ninguem preenche a mao e so confundem quem esta cadastrando.
        coordsLabel() {
            if (!this.hasCoords) return "Não localizado no mapa";

            return `${Number(this.dataset.data.address_lat).toFixed(6)}, ${Number(this.dataset.data.address_lng).toFixed(6)}`;
        },
    },

    watch: {
        searchAddress(val) {
            // this.select nao existe neste componente, entao a guarda original nunca
            // funcionava: o campo reconsultava o Maps a cada digito, inclusive com o
            // endereco ja escolhido. Agora so busca com texto novo e util.
            if (!val || val.length < 3) {
                this.dataset.addressLoading = false;
                return;
            }

            const atual = this.dataset.data.address;

            // Ao selecionar uma sugestao o Vuetify reescreve o search-input com o
            // texto do item, disparando este watch de novo. Sem sair aqui, o campo
            // buscava outra vez e o spinner nunca parava.
            if (atual && atual.name === val) {
                this.dataset.addressLoading = false;
                return;
            }

            this.getAddressByName(val);
        },
    },

    created() {
        this.loadData();
    },

    methods: {
        goBack() {
            this.$router.replace("/passageiros");
        },

        // Aceita numero decimal com sinal, dentro dos limites de lat/lng
        coordinateRule(value) {
            if (value === null || value === undefined || value === "") return true;

            const numero = Number(String(value).replace(",", "."));

            if (isNaN(numero)) return "Informe um número (ex.: -30.010129)";
            if (numero < -180 || numero > 180) return "Fora do intervalo válido";

            return true;
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.loadCustomers();
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id == "novo"
            this.page.title = this.page.isNew ? "Novo passageiro" : "Detalhes do passageiro";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Passageiros",
                disabled: false,
                to: "/passageiros",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Incluir passageiro" : "Detalhes do passageiro",
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v2/passengers/find/${this.$route.params.id}`);

                this.dataset.data = result.data.content.data

                // A lista de sugestoes usa { name, iid }. Montar o valor inicial com
                // outra chave fazia o autocomplete nunca reconhecer o item selecionado
                // e reconsultar o Maps em loop, deixando o campo carregando sem parar.
                this.dataset.data.address = { name: this.dataset.data.address, iid: this.dataset.data.address_iid }

                // A sugestao atual precisa estar na lista, senao o Vuetify a descarta
                this.$set(this.dataset, 'addresses', [this.dataset.data.address])

                // Coordenadas sem place do Maps indicam que foram informadas a mao:
                // deixa o switch ligado para o operador ver e poder editar.
                this.manualCoords = !!(this.dataset.data.address_lat && !this.dataset.data.address_iid)

                this.dataset.addresses = [this.dataset.data.address]

                this.loadCostCenters();

            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao encontrar as informações do passageiro, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadCustomers() {
            this.dataset.loading = true;
            try {
                const response = await axios.get('/api/v2/customers', { params: { start: 0, limit: 200 } });
                this.dataset.customers = response.data.content.data
            } catch (error) {
                console.error("Erro ao buscar customers:", error);
            } finally {
                this.dataset.loading = false;
            }

        },

        async loadCostCenters() {
            this.dataset.loading = true;
            try {
                const response = await axios.get('/api/v2/cost-centers', { params: { start: 0, limit: 200, search: { customer_id: this.dataset.data.customer_id } } });
                this.dataset.costCenters = response.data.content.data
            } catch (error) {
                console.error("Erro ao buscar customers:", error);
            } finally {
                this.dataset.loading = false;
            }

        },

        changeCustomer(customer) {
            if (!customer) {
                this.dataset.costCenters = []
                return;
            }

            this.loadCostCenters();
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o passageiro?',
                title: 'Salvar passageiro',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post(`/api/v2/passengers/create`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Passageiro salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o passageiro?',
                title: 'Atualizar passageiro',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v2/passengers/update/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Passageiro salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        getAddressByName: debounce(async function (name) {
            if (!name || String(name).trim().length < 3) {
                this.dataset.addresses = []
                this.addressSessionToken = null
                // Sem isto o spinner ficava girando quando a busca era abortada
                this.dataset.addressLoading = false;
                return
            }

            if (!this.addressSessionToken) {
                this.addressSessionToken = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}${Math.random()}`;
            }

            this.dataset.addressLoading = true;

            try {
                const response = await axios.get(`/api/v2/google-maps/find/${encodeURIComponent(name)}`, {
                    params: { sessiontoken: this.addressSessionToken }
                })

                // A busca ja devolve lat/lng: guardar aqui evita depender so do
                // place-details para preencher as coordenadas.
                const listAddresses = response.data.content.map((x) => {
                    return { name: x.address, iid: x.placeId, lat: x.lat, lng: x.lng }
                });

                this.$set(this.dataset, 'addresses', listAddresses);

            } catch (error) {

            } finally {
                this.dataset.addressLoading = false;
            }
        }, 500),

        async getCoordsFromPlaceId(placeId) {
            try {
                const response = await axios.get(`/api/v2/google-maps/place-details/${placeId}`, {
                    params: this.addressSessionToken ? { sessiontoken: this.addressSessionToken } : {}
                });

                const { coordinates, city, state, district } = response.data.content;

                return {
                    lat: coordinates.lat,
                    lng: coordinates.lng,
                    city,
                    state,
                    district
                };
            } catch (error) {
                console.error('Erro ao buscar coordenadas:', error);
                return null;
            }
        },

        async onAddressSelected(addressObj) {
            // Com o campo clearable, limpar dispara o change com null
            if (!addressObj || !addressObj.iid) {
                this.$set(this.dataset.data, 'address', null);
                this.$set(this.dataset.data, 'address_iid', null);
                this.$set(this.dataset.data, 'address_lat', null);
                this.$set(this.dataset.data, 'address_lng', null);

                return;
            }

            // dataset.data comeca vazio ({}), entao atribuir direto nao dispara a
            // reatividade do Vue 2 - o valor era gravado mas a tela seguia mostrando
            // "Nao localizado no mapa". O $set resolve.
            this.$set(this.dataset.data, 'address_iid', addressObj.iid);

            // A propria sugestao ja traz lat/lng: aplica na hora para o campo nao
            // ficar como nao localizado enquanto busca o detalhe.
            if (!this.manualCoords && addressObj.lat && addressObj.lng) {
                this.$set(this.dataset.data, 'address_lat', addressObj.lat);
                this.$set(this.dataset.data, 'address_lng', addressObj.lng);
            }

            this.dataset.addressLoading = true;

            try {
                const location = await this.getCoordsFromPlaceId(addressObj.iid);

                if (location) {
                    this.$set(this.dataset.data, 'city', location.city);
                    this.$set(this.dataset.data, 'state', location.state);
                    this.$set(this.dataset.data, 'district', location.district);

                    // Com coordenadas manuais ligadas, o que o operador digitou
                    // prevalece sobre o retorno do mapa
                    if (!this.manualCoords) {
                        this.$set(this.dataset.data, 'address_lat', location.lat);
                        this.$set(this.dataset.data, 'address_lng', location.lng);
                    }

                    this.addressSessionToken = null;
                }
            } catch (error) {
                this.$dialog.notify.error("Não foi possível localizar o endereço no mapa.",
                    { position: "top-right", timeout: 4000 });
            } finally {
                this.dataset.addressLoading = false;
            }
        },

        buildPayload() {

            let data = {
                name: this.dataset.data.name,
                registration: this.dataset.data.registration,
                phone_number: string.sanitizePhone(this.dataset.data.phone_number),
                address: this.dataset.data.address
                    ? (this.dataset.data.address.name || this.dataset.data.address)
                    : null,
                address_iid: this.dataset.data.address_iid,
                address_lat: this.dataset.data.address_lat,
                address_lng: this.dataset.data.address_lng,
                city: this.dataset.data.city,
                state: this.dataset.data.state,
                district: this.dataset.data.district,
                customer_id: this.dataset.data.customer_id,
                complement: this.dataset.data.complement,
                cost_center_id: this.dataset.data.cost_center_id
            }


            return data;
        },





    },
};
</script>

<style lang="scss">
/* Titulo de secao: menor que o card-group-title original, para os blocos
   agruparem os campos sem competir com o titulo da pagina. */
.section-title {
    font-size: 15px !important;
    font-weight: 600;
    color: #2c3153;
    padding-bottom: 8px;
    text-transform: none !important;
}

.coords-missing input {
    color: rgba(0, 0, 0, .45) !important;
    font-style: italic;
}

/* Verde quando localizado, ambar quando falta - acompanha o aviso do topo */
.coords-ok .v-input__append-inner .v-icon {
    color: #4caf50 !important;
}

.coords-missing .v-input__append-inner .v-icon {
    color: #f9a825 !important;
}

.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
